import React from 'react'
import { Image, Modal } from 'react-bootstrap'
import { IImageProps } from 'shared/interfaces/i-api-informationModal'
import './Modal.scss'

interface IModalHeaderProps {
	headerTitle: string
	headerImage: IImageProps
}

export const ModalHeader = ({
	headerTitle,
	headerImage,
}: IModalHeaderProps) => (
	<Modal.Header closeButton>
		<div className="modal-head">
			<Modal.Title>
				<div className="title-text font-color">{headerTitle}</div>
			</Modal.Title>
			<div className="header-image">
				<Image src={headerImage.src} alt={headerImage.alt} />
			</div>
		</div>
	</Modal.Header>
)
